import {Fragment, FunctionComponent, useLayoutEffect, useRef, useState} from 'react';
/* eslint-disable-next-line no-restricted-imports  */
import {createPortal} from 'react-dom';

const ATTEMPTS_COUNT = 5;

export function createPortalComponent<T extends Record<string, any> = {}>(
  nodeId: string | null,
  Component: FunctionComponent<T> = Fragment as FunctionComponent<T>
) {
  return function PortalComponent(props: T) {
    const nodeRef = useRef<HTMLElement | null>(null);

    const [isReady, setIsReady] = useState(false);
    const [attemptsLeft, setAttemptsLeft] = useState(ATTEMPTS_COUNT);

    useLayoutEffect(() => {
      if (!nodeId) {
        nodeRef.current = document.body;
        setIsReady(true);
        return;
      }

      let timeoutId: NodeJS.Timeout;
      const el = document.getElementById(nodeId);

      if (el) {
        nodeRef.current = el;
        setIsReady(true);
      } else if (attemptsLeft > 0) {
        timeoutId = setTimeout(() => {
          setAttemptsLeft(prevState => prevState - 1);
        }, 300);
      }

      return () => {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
      };
    }, [attemptsLeft, isReady]);

    if (!nodeRef.current) {
      return null;
    }

    return createPortal(<Component {...props} />, nodeRef.current);
  };
}
